import { SlideFade, Box, Flex, HStack, BoxProps } from '@chakra-ui/react'
import * as React from 'react'

import { LayoutContext } from '../../context/LayoutContext'
import ButtonTextNav from '../buttons/ButtonTextNav'
import Logo from '../icons/Logo'
import SVG from '../common/SVG'

export type NavPCProps = BoxProps & {}

const NavPC: React.FC<NavPCProps> = ({ ...others }) => {
  const [isNavVisible, setIsNavVisible] = React.useState(false)
  const { state } = React.useContext(LayoutContext)

  React.useEffect(() => {
    setIsNavVisible(state.initializeFinished)
  }, [state.initializeFinished])

  return (
    <>
      <Box w="100%" minW="contentMinWPC" h="120px" bg="white" {...others}>
        <Flex h="100%">
          <Box as="h1" flex="1" display="flex" pl="30px" pr="30px">
            <SVG maxW="379px" svg={<Logo />} />
          </Box>
          <SlideFade in={isNavVisible} offsetX="-10px" offsetY="0px">
            <HStack spacing="45px" pr="40px" h="120px">
              <ButtonTextNav to="/" ja="トップ" en="TOP" />
              <ButtonTextNav to="/about/" ja="AYDAとは" en="ABOUT" />
              <ButtonTextNav to="/award/" ja="アワード情報" en="AWARD" />
              <ButtonTextNav to="/entry/" ja="結果発表" en="RESULT" />
              <ButtonTextNav to="/internship/" ja="インターンシップ" en="INTERNSHIP" />
              <ButtonTextNav to="/summit/" ja="アジア学生サミット" en="SUMMIT" />
              <ButtonTextNav to="/event/" ja="アーカイブ" en="ARCHIVE" />
              <ButtonTextNav to="https://twitter.com/ayda_japan/" ja="twitter" en="ayda_japan" />
            </HStack>
          </SlideFade>
        </Flex>
      </Box>
    </>
  )
}

export default NavPC
